import {ECOMM_PAGE_TYPES} from './constants'

/**
 * Resolves the GTM `ecomm_pagetype` for a given path, or `undefined` if we
 * don't map it on MRT yet.
 *
 * Scope today is the homepage only. On SFRA the `int_gtm_sfra` cartridge
 * seeded `ecomm_pagetype: "HomePage"` into the data layer server-side before
 * the GTM snippet, so Google Ads dynamic-remarketing tags fired with the
 * correct page type. SFCC-10847 moved the homepage SFRA -> MRT and there was
 * no MRT equivalent, so the migrated homepage stopped reporting its page type.
 *
 * `url.locale` is `none` and the site is hostname-derived, so the homepage
 * path is exactly `/`.
 *
 * @param {string} pathname - `window.location.pathname`
 * @returns {string|undefined} the `ecomm_pagetype` value, or `undefined`
 */
export const getEcommPageType = (pathname) => {
    if (pathname === '/') return ECOMM_PAGE_TYPES.home
    return undefined
}

/**
 * Builds the initial GTM data layer to seed at `TagManager.initialize()` time.
 * react-gtm-nonce injects this as an inline (nonce'd) script that runs before
 * the gtm.js loader, so the value is present in `window.dataLayer` when the
 * container's page view fires — mirroring SFRA's pre-snippet data-layer seed.
 *
 * Returns `undefined` when there's nothing to seed so the caller can omit the
 * `dataLayer` arg entirely.
 *
 * @returns {{ecomm_pagetype: string}|undefined}
 */
export const getInitialGtmDataLayer = () => {
    if (typeof window === 'undefined') return undefined
    const ecommPageType = getEcommPageType(window.location.pathname)
    return ecommPageType ? {ecomm_pagetype: ecommPageType} : undefined
}
